import { ActionType as ProgramPreviewActionType } from 'store/programPreview';
import { actionTypes as programPreviewAT } from 'store/programPreview';
import { ProgramsActionType } from './programs.actionCreators';
import {
	FLUSH_PROGRAM,
	REQUEST_ACTIVE_FAILURE,
	REQUEST_ACTIVE_LOADING,
	REQUEST_ACTIVE_SUCCESS,
	REQUEST_FINISH_BUTTON_SUCCESS,
	REQUEST_FINISH_MANUALLY,
	REQUEST_FINISH_MANUALLY_FAILURE,
	REQUEST_FINISH_MANUALLY_SUCCESS,
} from './programs.actionTypes';

export type ProgramType = {
	id: string;
	externalId: string;
	status: string;
	numberOfDays: number;
	todayDayNumber: number;
	finishProgramButton: any; // was: boolean, should be: object-type
};

export type ProgramsStateType = {
	byId?: { [key: string]: ProgramType };
	allIds: string[];
	hasLoadedActivePrograms: boolean;
	isLoadingActivePrograms: boolean;
	isLoadingManualFinish: boolean;
	hasManuallyFinished: boolean;
};

export type RootStateType = {
	programs: ProgramsStateType;
};

// Reducer
// ------------------------------------

export const initialState: ProgramsStateType = {
	allIds: [],
	hasLoadedActivePrograms: false,
	isLoadingActivePrograms: false,
	isLoadingManualFinish: false,
	hasManuallyFinished: false,
};

export default (state: ProgramsStateType = initialState, action: ProgramsActionType | ProgramPreviewActionType) => {
	switch (action.type) {
		case programPreviewAT.START_SUCCESS:
		case programPreviewAT.OVERWRITE_SUCCESS:
			const activeProgram: any = (action as any).activeProgram || {};

			return {
				...state,
				hasLoadedActivePrograms: true,
				allIds: [activeProgram.id],
				byId: {
					activeProgramId: {
						id: activeProgram.id,
						status: activeProgram.status,
						numberOfDays: activeProgram.numberOfDays,
						todayDayNumber: activeProgram.todayDayNumber,
						finishProgramButton: activeProgram.finishProgramButton,
					},
				},
			};

		case FLUSH_PROGRAM as any:
			return { ...initialState, hasLoadedActivePrograms: true };

		case REQUEST_ACTIVE_LOADING:
			return { ...state, isLoadingActivePrograms: action.status };

		case REQUEST_ACTIVE_SUCCESS:
			action.activePrograms = Array.isArray(action.activePrograms) ? action.activePrograms : [];
			return {
				...state,
				hasLoadedActivePrograms: true,
				allIds: action.activePrograms.map((program) => program.id),
				byId: action.activePrograms.reduce(
					(acc: Object, cur: ProgramType): any /*ProgramType*/ => {
						acc[cur.id] = {
							id: cur.id,
							externalId: cur.externalId,
							status: cur.status,
							numberOfDays: cur.numberOfDays,
							todayDayNumber: cur.todayDayNumber,
							finishProgramButton: cur.finishProgramButton,
						};

						return acc;
					},
					{}
				),
			};

		case REQUEST_ACTIVE_FAILURE:
			return {
				...state,
				error: (action as any).message,
			};

		case REQUEST_FINISH_MANUALLY:
			return {
				...state,
				isLoadingManualFinish: true,
			};

		case REQUEST_FINISH_MANUALLY_SUCCESS:
			return {
				...state,
				isLoadingManualFinish: false,
				hasManuallyFinished: true,
			};

		case REQUEST_FINISH_MANUALLY_FAILURE:
			return {
				...state,
				isLoadingManualFinish: false,
				hasManuallyFinished: false,
			};

		case REQUEST_FINISH_BUTTON_SUCCESS:
			if (!state.byId) {
				return { ...state };
			}
			return {
				...state,
				byId: {
					...state.byId,
					[action.activeProgram.id]: {
						...state.byId[action.activeProgram.id],
						finishProgramButton: action.activeProgram.finishProgramButton,
					},
				},
			};

		default:
			return state;
	}
};
